export default __webpack_public_path__ + "static/media/icon-bars.64f549aa.svg";